interface IconProps {
  name: string
  className?: string
}

export function Icon({ name, className = '' }: IconProps) {
  return <i className={`fa-solid fa-${name} ${className}`} aria-hidden="true" />
}
